(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gemmarii-classic-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gemmarii-choice')) {
  customElements.define('gemmarii-choice', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.mainProduct') || this.closest('.shopify-section');
      if (!this.root) return;
      this.values = JSON.parse(this.dataset.values || '{}');
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateChoice());
      };
      this.root.addEventListener('change', this.refresh);
      this.root.addEventListener('click', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.root, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-selected', 'checked', 'selected'] });
      this.updateChoice();
    }
    updateChoice() {
      const name = this.dataset.optionName;
      const list = [...this.root.querySelectorAll('.variant-options')].find(el => el.dataset.optionName === name);
      const selected = list?.querySelector('.variant-option-item.selected') || list?.querySelector('[aria-selected="true"]');
      const select = [...this.root.querySelectorAll('select')].find(el => el.name === `options[${name}]` || el.dataset.optionName === name);
      const value = selected?.dataset.swatch ?? select?.value;
      const text = this.values[value];
      if (text !== undefined && this.textContent !== text) this.textContent = text;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change', this.refresh);
      this.root?.removeEventListener('click', this.refresh);
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gemmarii-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gemmarii-faq')) {
  customElements.define('gemmarii-faq', class extends HTMLElement {
    normalise(value) {
      return value.toLowerCase().replaceAll('æ','ae').replaceAll('ø','o').replaceAll('å','a').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
    }
    terms(value) {
      const groups = [
        ['ringmal','ringstorrelse','ringstorrelser','storrelse','storrelsen','storrelser','resize'],
        ['fragt','forsendelse','levering','leveringstid','leveringstiden','shipping','modtager','ankommer'],
        ['retur','returnere','returnering','fortrydelse','fortryde','return'],
        ['gammelt','gamle','eget','genbrug','redesign','omsmeltning'],
        ['rengoring','rengore','pleje','rensning'],
        ['reparation','reparere','repareret'],
        ['gravering','gravere','indgravering'],
        ['smykkepas','dokumentation','certifikat'],
        ['ring','ringe','ringen','vielsesring','vielsesringe'],
        ['diamant','diamanten','diamanter','brillant','brillanter']
      ];
      return this.normalise(value).split(/\s+/).filter(Boolean).map(word => {
        const group = groups.find(items => items.includes(word));
        return group ? group[0] : word;
      });
    }
    matches(query, text) {
      const stop = new Set(['hvor','hvordan','hvad','hvornar','hvilken','hvilke','kan','jeg','i','vi','du','er','det','den','de','der','en','et','at','og','eller','til','af','med','om','pa','for','mit','min','mine','jer','jeres','hos','skal','har','far','faar','lang','tid','tager']);
      const terms = this.terms(query).filter(word => !stop.has(word));
      const words = new Set(this.terms(text));
      return terms.length > 0 && terms.every(word => words.has(word));
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.input = this.querySelector('input');
      this.questions = [...this.querySelectorAll('.gm-faq__question')];
      this.groups = [...this.querySelectorAll('.gm-faq__group')];
      const aliases = {'eget-guld':'gammelt guld omsmeltning redesign','leveringstid':'leveringstid','ringstoerrelse':'ringmal'};
      this.index = this.questions.map(question => question.querySelector('summary').textContent + ' ' + question.querySelector('.gm-faq__answer').textContent + ' ' + (aliases[question.id] || ''));
      this.querySelector('.gm-faq__search').hidden = false;
      this.input.addEventListener('input', () => this.filter(), options);
      this.querySelector('[data-clear]').addEventListener('click', () => { this.input.value = ''; this.filter(); this.input.focus(); }, options);
      window.addEventListener('hashchange', () => this.revealHash(), options);
      this.querySelector('.gm-faq__nav').addEventListener('click', event => {
        if (event.target.closest('a')) { this.input.value = ''; this.filter(); }
      }, options);
      this.filter();
      this.revealHash();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.ready = false;
    }
    filter() {
      const query = this.input.value.trim();
      let count = 0;
      this.questions.forEach((question, index) => {
        const matches = !query || this.matches(query, this.index[index]);
        question.hidden = !matches;
        question.open = false;
        if (matches) count++;
      });
      this.groups.forEach(group => { group.hidden = ![...group.querySelectorAll('details')].some(question => !question.hidden); });
      this.querySelector('[data-empty]').hidden = count !== 0;
      const status = this.querySelector('[data-count]');
      status.textContent = query ? status.dataset.label + ' ' + count : '';
    }
    revealHash() {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return;
      this.input.value = '';
      this.filter();
      if (target.matches('details')) target.open = true;
      requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
